export const ICON_SIZE = 48

// Feature Control Flags
export const ALLOW_SUBSCRIPTIONS = false
export const ALLOW_SUBMIT_LORE = false
export const SHOW_LISTENERS_AND_RATINGS = false
export const LISTEN_LOCALLY = false